import assetPath from '/app/packages/video/video-upload/src/assets/video.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')